module.exports = __webpack_public_path__ + "img/sbg2.dbfad7f4.png";